import React from "react";
import axios from 'axios';
import './Myorders.css';
import Breadcrumb from '../Components/Breadcrumb';
//import { Link } from 'react-router-dom';
import AuthService from '../Services/auth.service';
//import Breadcrumb from '../Components/Breadcrum';
import Moment from 'react-moment';
import Loader from "../Components/Loader";


import toast, { Toaster } from 'react-hot-toast';
class Myorders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : [],rate:[],year: null, month: null, day: null, Mmonth:'',ismonth:false,current:[],load:'',checkLoad:true,prevmonth:''
            
    
        };
        this.handleChange = this.handleChange.bind(this);
       // this.handleInputChange = this.handleInputChange.bind(this);
       const year = (new Date()).getFullYear();
       const startYear=2022
       const yearLength=year-startYear
        this.years = Array.from(new Array(yearLength+1),(val, index) => index + startYear);

    }

  componentDidMount(){
    const dateObj = new Date()
    const monthName = dateObj.toLocaleString("default", { month: "2-digit" })
    const getMonth = dateObj.toLocaleString('default', { month: 'long' });
    
   
    this.setState({current:monthName})
    this.getData(monthName,getMonth)
  }
 getData(Month,getMonthname){
    //alert(Month)

//alert(getMonthname)
    this.setState({Mmonth:getMonthname})
       //this.setState({mon:monthName})
        const USR_TOKEN = localStorage.getItem("userToken")
       // alert(monthName)
        if(USR_TOKEN){
           //alert(USR_TOKEN)
            const user =  AuthService.getCurrentUser();
            this.setState({profile:user})
           
            this.setState({selectMonth:Month})
          //alert(this.state.Mmonth)
           // console.log(process.env.REACT_APP_API_URL + 'api/method/wolly.api.my_orders?month='+monthName)
            axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.my_orders?month='+Month,{
                headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
            })
            .then(response=>{
                this.setState({menu:response.data['message']})
                this.setState({rate:response.data['message']['items']})
               // console.log(response.data['message'])
               this.setState({load:''})
               this.setState({checkLoad:false})
            })
            .catch(response=>{
               //alert(" Sorry something went wrong. Please log in ")
               toast.error("Sorry something went wrong. Please log in ")
            })
           
        }
        else{
            //alert("Not Logged in")
        }
    }

     
    handleChange(event) 
    {
       //this.setState({Mmonth: event.target.value});
       this.setState({ismonth:true});
       this.setState({current:''})
       //althisert(.state.Mmonth)
       //  alert(event.target.value)
       this.setState({Mmonth:event.target.value})
       this.getData(event.target.value)
       //event.preventDefault();
     }
     
     
     currentYear(Month,getMonthname){
    
        this.setState({Mmonth:getMonthname})
       //this.setState({mon:monthName})
        const USR_TOKEN = localStorage.getItem("userToken")
       // alert(monthName)
        if(USR_TOKEN){
           //alert(USR_TOKEN)
            const user =  AuthService.getCurrentUser();
            this.setState({profile:user})
           
            this.setState({selectMonth:Month})
          //alert(this.state.Mmonth)
           // console.log(process.env.REACT_APP_API_URL + 'api/method/wolly.api.my_orders?month='+monthName)
            axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.my_orders?month='+Month,{
                headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
            })
            .then(response=>{
                this.setState({menu:response.data['message']})
                this.setState({rate:response.data['message']['items']})
               // console.log(response.data['message'])
               this.setState({load:''})
               this.setState({checkLoad:false})
            })
            .catch(response=>{
               //alert(" Sorry something went wrong. Please log in ")
               toast.error("Sorry something went wrong. Please log in ")
            })
           
        }
        else{
            //alert("Not Logged in")
        }
     }


     handleSubmit = event => {

        const cancelData= {
        name:event
        }
        
        const USR_TOKEN = localStorage.getItem("userToken")
          if(USR_TOKEN){
             //alert(USR_TOKEN)
              const user =  AuthService.getCurrentUser();
              this.setState({profile:user})
              this.setState({load:'opcty'})
                axios.post(process.env.REACT_APP_API_URL+'api/method/ecom.api.cancel_order',cancelData,{
                headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
                
                })      
                .then(  
                    res =>{
                        //this.setState({value:true})
                        //window.location.href = "/my-orders.html"; 
                       
                        this.getData(this.state.Mmonth)
                        
                        } 
                )
                .catch(
                    err =>{
                        this.setState({checkLoad:false})
                        this.setState({load:false})
                        alert("failed")
                    }
                )
          }
          else{
            alert("Not Logged in")
            window.location.href="/"
        }

        /* if(this.state.value){
            alert("success")
            window.location.href = "/my-account.html";

        } 
        else{
            alert("failed")
        }       */
            
        
      }
  render() {
      
     //let selectedMonth = moment(this.state.selectMonth, 'M').format('MMMM');
     // alert(this.state.selectMonth)
     // alert(this.state.Mmonth)
    return this.state.checkLoad ? <Loader/> : <div>
         <Breadcrumb head="My Orders"/>
         <Toaster
            position="top-center"
            reverseOrder={false}
        />
         <div className="container-fluid mb-5">
        <div className="container">
      
       {/*  <nav aria-label="breadcrumb">
            <ol className="breadcrumb2 breadcrumb brdcum">
                <li className="breadcrumb"><a href="index.html"> Home&nbsp; </a></li>
                <li className="breadcrumb"> / My Orders</li>
            </ol>
            </nav> */}
            <div className="container">
           <div className="row mt-3">
                <div className="col-md-6">
                    <h2>My Orders</h2>
                    {/* <div className="float-right">
                        <MonthPicker
                            name="MonthYear"
                            allowedYears={{ "after": new Date().getFullYear() - 2 }}
                            selectedMonth={this.state.month}
                            selectedYear={this.state.year}
                            onChangeYear={year => this.setState({ year: year })}
                            onChangeMonth={month => this.setState({ month: month })} 
                        
                        /> 
                    </div> */}
                    {/* <div className="">
                        <h6  className="small-header opacity-header">For the year of</h6>
                            <form className="form-inline">
                                <div className="stepper-widget">
                                    <div className="">

                                        <select className="form-controls header-space "   onChange={(e)=>this.currentYear(e.target.value)} >
                                                                    
                                            {
                                                this.years.map((year, index) => {
                                                    return <option key={`year${index}`} value={year}>{year}</option>
                                                })
                                            }
                                                                    
                                        </select>
                                    </div>
                                </div>
                            </form>
                        </div> */}
                </div>
                <div className=" col-md-7 ">
                    <p className="second-line">You can manage your past orders here</p>
                    <h6  className="small-header opacity-header">For the month of</h6>
                    
					
							
                    <form className="form-inline">
									<div className="stepper-widget">
										<div className="">
										    <select className="form-controls header-space "   onChange={this.handleChange}  >
                                            {this.state.selectMonth !== '01' ? <option value='1' >January</option>:<option value='1 ' selected>January</option>}
                                             {this.state.selectMonth !== '02' ?<option value='2'  >February</option> : <option value='2 'selected  >February</option>}
                                             {this.state.selectMonth !== '03' ? <option value='3'  >March</option> : <option value='3 'selected  >March</option>}
                                            {this.state.selectMonth !== '04' ? <option value= '4' >April</option> : <option value= '4 'selected >April</option>}
                                            {this.state.selectMonth !== '05' ?  <option value='5'  >May</option> : <option value='5 'selected  >May</option>}
                                            {this.state.selectMonth !== '06' ? <option value='6'  >June</option> : <option value='6 'selected >June</option>}
                                            {this.state.selectMonth !== '07' ?<option value= '7'  >July</option> :<option value= '7 ' selected >July</option>}
                                            {this.state.selectMonth !== '08' ?<option value='8'  >August</option> :<option value='8 'selected  >August</option>}
                                            {this.state.selectMonth !== '09' ?<option value='9' >September</option> : <option value='9 'selected >September</option>}
                                            {this.state.selectMonth !== '10' ?<option value='10' >October</option> : <option value='10 'selected >October</option>}
                                            {this.state.selectMonth !== '11' ? <option value='11' >November</option> :<option value='11 'selected >November</option>}
                                            {this.state.selectMonth !== '12' ?<option value='12' >December</option> : <option value='12 'selected >December</option>}
										    </select>
									    </div>
							        </div>
								</form> 


                                {this.state.menu.length ? this.state.menu.map((itm,k)=>{
                                    console.log(itm)
            return(				
					
                    <div  key={k} className={this.state.load? 'opcty' : ''}>
                    <h6 className="opacity-header"><Moment format="DD MMMM yyyy" withTitle>{itm.transaction_date}</Moment></h6>
                    
                        <span className={itm.status === 'Cancelled' ? 'Cancelled' :'today-delivery' } >{itm.status} </span>
                        <div className="mt-2 "> 
                        <span className="rs-right float-right mt-1 amnt-width">Rs {itm.grand_total}</span>  
                        <span className="float-right flt-nn mr-2">
                            <a href={'/orders-details/'+itm.name}>
                                <button type="button" className=" add-to-select btn-curve btn btn-outline-success waves-effect waves-light tag-btn ">View Order Details</button>
                            </a>
                            <br/>
                          {/*   {itm.status === 'To Deliver and Bill' || itm.status === 'To Deliver' ? <button type="button" className=" add-to-select btn-curve btn btn-outline-success waves-effect waves-light tag-btn cnl-width mt-2"    onClick={(event) => {if(window.confirm(' Are You Sure To Cancel the Order?')){this.handleSubmit(itm.name)};}}>Cancel Order</button> :'' } */}
                            
                            
                        </span>
                   
                    </div>
                        <ul className="subtotal subtotal-list ">
                        {itm.items.map((item,p)=>{
            return(				   
            
            <li className="subtotal " key={p}><img src={process.env.REACT_APP_API_URL +item.image} className="product-thumbnails" alt=""/><p className="itm ">{item.item_name} x {item.qty}</p> </li>
                            )
                    })}
                         
                        </ul>
                        <hr className="mt-5"/>
                    </div>
                     )
                    }) : <h3 className="mt-5">There is no order found in this month !</h3>}
                    
                   
                  {/*   <div key={k}>
                    <h6 className="opacity-header">01 september 2020</h6>
                    
                    <span className="today-delivery">Delivering Today,  21th at 4:00pm </span> <span className="float-right flt-nn "> <Link to="/orders-details.html"><button type="button" className=" add-to-select btn-curve btn btn-outline-success waves-effect waves-light tag-btn  ">View Order Details</button></Link><span className="ml-1 rs-right">₹40</span></span>
                       
                        
                        <ul className="subtotal subtotal-list ">
                            <li className="subtotal "><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm ">Item Name x 1</p> </li>
                            <li className="subtotal"><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1</p> </li>
                            <li className="subtotal"><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1</p> </li>
                        </ul>
                        <hr/>
                    </div>
                    <div>
                    <h6 className="opacity-header">01 september 2020</h6>
                        
                        <span className=" Delivered">Delivered</span> <span className="float-right flt-nn"><Link to="/orders-details.html"><button type="button" className=" add-to-select btn-curve btn btn-outline-success waves-effect waves-light  tag-btn ">View Order Details</button></Link><span className="ml-1 rs-right">₹40</span></span>
                       
                        <ul className="subtotal subtotal-list">
                        <li className="subtotal"><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1</p> </li>
                        <li className="subtotal"><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1</p> </li>
                        </ul>
                    </div>
                    <hr/>
                    <div>
                    <h6 className="opacity-header">01 september 2020</h6>
                        <span className="Cancelled ">Cancelled</span> <span className="float-right flt-nn"><Link to="/orders-details.html"><button type="button" className=" add-to-select btn-curve btn btn-outline-success waves-effect waves-light  tag-btn ">View Order Details</button></Link><span className="ml-1 rs-right">₹40</span></span>
                        <ul className="subtotal subtotal-list">
                        <li className="subtotal"><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1</p> </li>
                           <li className="subtotal"><img src="assets/images/product-img/product-img-1.jpg" className="product-thumbnails" alt=""/><p className="itm">Item Name x 1</p> </li>
                        </ul>
                    </div> */}
                </div>
            </div>
        </div>
</div>
</div>
</div>
}
}

export default Myorders;
